module.exports = __webpack_public_path__ + "img/home_banner_web_BG4.6aed90ee.png";